import useLanguage from '@/utils/hooks/useLanguage';
import cn from 'classnames';

export enum MarketListFilter {
    'All' = 0,
    'FX' = 1,
    'Crypto' = 2,
    'Index and Comm CFDs' = 3
}

interface TabFiltersMainProps {
    className?: string;
    children: React.ReactNode;
}

interface TabFiltersFilterProps {
    className?: string;
    filter: {
        label: any;
        value: any;
    };
    selectedFilter: any;
    setSelectedFilter: (value: any) => void;
}

interface TabFiltersCommonProps {
    filters: {
        label: any;
        value: any;
    }[];
    selectedFilter: any;
    setSelectedFilter: (value: any) => void;
}

const TabFilters = {
    Main: ({ className, children }: TabFiltersMainProps) => {
        return (
            <div
                className={cn(
                    'flex min-h-fit overflow-x-auto border-b border-b-brand-neutral-700 p-1 gap-1',
                    className
                )}>
                {children}
            </div>
        );
    },
    Filter: ({ className, filter, selectedFilter, setSelectedFilter }: TabFiltersFilterProps) => {
        return (
            <button
                type="button"
                key={filter.label}
                className={cn(
                    'p-1 px-2 text-sm font-medium leading-none h-[29px] text-brand-text focus:outline-none whitespace-nowrap rounded-sm',
                    {
                        'bg-brand-primary text-brand-module-title': selectedFilter === filter.value,
                        'text-brand-neutral-400 hover:bg-brand-neutral-700 hover:text-brand-text':
                            selectedFilter !== filter.value
                    },
                    className
                )}
                onClick={() => setSelectedFilter(filter.value)}>
                {filter.label}
            </button>
        );
    },
    Common: ({ filters, selectedFilter, setSelectedFilter }: TabFiltersCommonProps) => {
        const lang = useLanguage();
        return (
            <div className="flex gap-1" dir={lang.dir}>
                {filters?.map((filter, index) => {
                    return (
                        <button
                            key={filter.label}
                            className={cn(
                                'p-1 px-2 text-sm font-medium leading-none h-[29px] text-brand-text focus:outline-none whitespace-nowrap rounded-sm',
                                {
                                    'bg-brand-primary': selectedFilter === filter.value,
                                    'hover:bg-brand-neutral-700': selectedFilter !== filter.value
                                }
                            )}
                            onClick={() => setSelectedFilter(filter.value)}>
                            {filter.label}
                        </button>
                    );
                })}
            </div>
        );
    }
};

export default TabFilters;
